<template>
  <div>
    <h3>上传PDF题库文件</h3>
    <el-form @submit.native.prevent="saveFile" :inline="true">
      <el-form-item label="选择网校">
        <el-select
          v-model="model.maID"
          multiple
          @change="getMajor"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="model.chID"
          @change="getCourse"
          multiple
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          v-model="model.coID"
          @change="getClass"
          multiple
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select v-model="model.clID" multiple placeholder="三级分类">
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-upload
        class="upload-demo"
        drag
        :action="$http.defaults.baseURL + '/files/file'"
        multiple
        :on-preview="handlePreview"
        :on-success="fileUpload"
        :file-list="fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          接收：【pdf,word,exlx,jpg,png】
        </div>
      </el-upload>

      <el-form-item style="margin-top: 25px">
        <el-button type="primary" native-type="submit">点击创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileList: [],
      files: [],
      major: [],
      channel: [],
      course: [],
      shclass: [],
      model: {
        fileList: "",
      },
    };
  },

  methods: {
    async saveFile() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
          clID: this.model.clID,
          files: this.files,
        };
        const res = await this.$http.post("/files/upload", params);
        if (res.status === 200) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.$router.push("/files/list");
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        //console.log(getchannel);
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
      //console.log(item);
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.shclass = getclass.data;
      } catch (error) {
        console.log(error);
      }
    },
    fileUpload(res, file, fileList) {
      //console.log(res.file);
      //this.fileList = res.file;
      //console.log(fileList);
      try {
        this.files = fileList;
      } catch (error) {
        console.log(error);
      }
    },
    handlePreview(file) {
      console.log(file);
    },
  },

  created() {
    this.getMajor();
    this.getChannel();
  },
};
</script>

<style></style>
